import { ReactNode } from 'react';
import {
  createBrowserRouter,
  Navigate,
  RouterProvider
} from 'react-router-dom';
import { LoginScreen } from '@/screens/auth/LoginScreen';
import { VerifyScreen } from '@/screens/auth/VerifyScreen';
import { MainLayout } from '@/layouts/MainLayout';
import { OverviewScreen } from '@/screens/overview/OverviewScreen';
import { NodesScreen } from '@/screens/nodes/NodesScreen';
import { GroupsScreen } from '@/screens/groups/GroupsScreen';
import { TokensScreen } from '@/screens/tokens/TokensScreen';
import { EarningsScreen } from '@/screens/earnings/EarningsScreen';
import { StatementsScreen } from '@/screens/statements/StatementsScreen';
import { AlertsScreen } from '@/screens/alerts/AlertsScreen';
import { SettingsScreen } from '@/screens/settings/SettingsScreen';
import { useAuthStore } from '@/store/authStore';

function RequireAuth({ children }: { children: ReactNode }) {
  const token = useAuthStore(s => s.token);
  if (!token) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function RedirectIfAuthed({ children }: { children: ReactNode }) {
  const token = useAuthStore(s => s.token);
  if (token) return <Navigate to="/" replace />;
  return <>{children}</>;
}

const router = createBrowserRouter([
  {
    path: '/login',
    element: (
      <RedirectIfAuthed>
        <LoginScreen />
      </RedirectIfAuthed>
    )
  },
  {
    path: '/auth/verify',
    element: <VerifyScreen />
  },
  {
    path: '/',
    element: (
      <RequireAuth>
        <MainLayout />
      </RequireAuth>
    ),
    children: [
      { index: true, element: <OverviewScreen /> },
      { path: 'nodes', element: <NodesScreen /> },
      { path: 'groups', element: <GroupsScreen /> },
      { path: 'tokens', element: <TokensScreen /> },
      { path: 'earnings', element: <EarningsScreen /> },
      { path: 'statements', element: <StatementsScreen /> },
      { path: 'alerts', element: <AlertsScreen /> },
      { path: 'settings', element: <SettingsScreen /> }
    ]
  },
  { path: '*', element: <Navigate to="/" replace /> }
]);

export function AppRouter() {
  return <RouterProvider router={router} />;
}
